import React, { useEffect, useState } from "react";
import { Drawer, Form, Select, Button, message } from "antd";
import PropTypes from "prop-types";
import { BASE_CRM_URL } from "../../../components/config/config";

import QuillEditor from "../Sales/DynamicScreen/QuillEditor";
import { Spin } from "antd";
import Swal from "sweetalert2";
// Static WhatsApp templates
const whatsappTemplates = [
  {
    name: "lead_welcome",
  },
  {
    name: "create_customere",
  },
];
const replacePlaceholders = (template = "", values = {}) => {
  return String(template).replace(/\{([a-zA-Z0-9_]+)\}/g, (match, key) => {
    const value = values[key];
    return value !== undefined && value !== null ? String(value) : match;
  });
};

const SendMessageDrawer = ({ open, onClose, onSubmit }) => {
  const [form] = Form.useForm();

  const [recordType, setRecordType] = useState("lead");
  const [selectedRecipient, setSelectedRecipient] = useState(null);
  const [selectedEmailTemplate, setSelectedEmailTemplate] = useState(null);
  const [selectedWhatsAppTemplate, setSelectedWhatsAppTemplate] =
    useState(null);

  const [sendEmail, setSendEmail] = useState(true);
  const [sendWhatsApp, setSendWhatsApp] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const [relatedOptions, setRelatedOptions] = useState([]);
  const [relatedLoading, setRelatedLoading] = useState(false);
  const [selectedRelated, setSelectedRelated] = useState(null);
  const [selectedRelatedName, setSelectedRelatedName] = useState("");

  // Customers / Leads
  const [customerOptions, setCustomerOptions] = useState([]);
  const [leadOptions, setLeadOptions] = useState([]);
  const [selectedLead, setSelectedLead] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState([]);
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [emailTemplateLoading, setEmailTemplateLoading] = useState(false);

  const [emailTemplate, setEmailTemplate] = useState("");
  const [prefilledMessage, setPrefilledMessage] = useState("");

  const [emailSubject, setEmailSubject] = useState("");

  const [showValidation, setShowValidation] = useState(false);
  const [saving, setSaving] = useState(false);

  const getRelatedTypes = async () => {
    try {
      setRelatedLoading(true);

      const response = await fetch(`${BASE_CRM_URL}RelatedToType`);
      const data = await response.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        const options = data.ResultData.map((item) => ({
          value: item.Id,
          label: item.RelatedToType,
          name: item.RelatedToType,
        }));

        setRelatedOptions(options);
      } else {
        setRelatedOptions([]);
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
      message.error("Failed to load related types");
    } finally {
      setRelatedLoading(false);
    }
  };

  console.log(prefilledMessage);

  const getCustomers = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}customers/GetCustomers`);

      const data = await response.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        const options = data.ResultData.map((item) => ({
          value: String(item.customerId),
          label: item.company || item.name || `Customer ${item.customerId}`,
          record: item,
        }));

        setCustomerOptions(options);
      } else {
        setCustomerOptions([]);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
      message.error("Failed to load customers");
    }
  };

  const getLeads = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}leads/GetLeads`);

      const data = await response.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        const options = data.ResultData.map((item) => ({
          value: String(item.id),
          label: item.name || `Lead ${item.id}`,
          record: item,
        }));

        setLeadOptions(options);
      } else {
        setLeadOptions([]);
      }
    } catch (error) {
      console.error("Error fetching leads:", error);
      message.error("Failed to load leads");
    }
  };

  const getEmailTemplates = async () => {
    try {
      setEmailTemplateLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}Email/GetCampaignEmailTemplates`,
      );

      const data = await response.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        const templates = data.ResultData.filter(
          (item) => Number(item.active) === 1,
        ).map((item) => ({
          value: String(item.emailtemplateid),
          label: item.name,
          subject: item.subject,
          message: item.message,
          slug: item.slug,
        }));

        setEmailTemplates(templates);
      } else {
        setEmailTemplates([]);
      }
    } catch (error) {
      console.error("Error fetching email templates:", error);
      setEmailTemplates([]);
    } finally {
      setEmailTemplateLoading(false);
    }
  };

  const getSelectedRecipient = () => {
    if (isLead) {
      const option = leadOptions.find((item) => item.value === selectedLead[0]);

      return option?.record || null;
    }

    if (isCustomer) {
      const option = customerOptions.find(
        (item) => item.value === selectedCustomer[0],
      );

      return option?.record || null;
    }

    return null;
  };

  useEffect(() => {
    getRelatedTypes();
    getCustomers();
    getLeads();
    getEmailTemplates();
  }, []);

  useEffect(() => {
    if (open) {
      form.resetFields();
      form.setFieldsValue({
        relType: "lead",
        recipientId: undefined,
      });

      setRecordType("lead");
      setSelectedRecipient(null);
      setSelectedEmailTemplate(null);
      setSelectedWhatsAppTemplate(null);
      setSendEmail(true);
      setSendWhatsApp(true);
    }
  }, [open, form]);

  const handleRelatedChange = (value) => {
    const selectedOption = relatedOptions.find(
      (option) => option.value === value,
    );

    const relatedName = (selectedOption?.name || "").toLowerCase();

    const leadSelected = relatedName.includes("lead");
    // const customerSelected =
    //   relatedName.includes("customer") || relatedName.includes("client");

    setSelectedRelated(value);
    setSelectedRelatedName(selectedOption?.name || "");
    setRecordType(leadSelected ? "lead" : "customer");

    setSelectedLead([]);
    setSelectedCustomer([]);
    setSelectedRecipient(null);

    setEmailTemplate("");
    setEmailSubject("");
    setPrefilledMessage("");
    setSelectedEmailTemplate(null);
    setSelectedWhatsAppTemplate(null);
  };

  const handleWhatsAppTemplateChange = (value) => {
    const template = whatsappTemplates.find((item) => item.name === value);

    setSelectedWhatsAppTemplate(template || null);
  };

  const handleFinish = async (values) => {
    setShowValidation(true);
    setSaving(true);
    if (!selectedRelated) {
      message.error("Please select a related type.");
      return;
    }

    if (!selectedRecipient) {
      message.error("Please select a lead or customer.");
      return;
    }

    if (!sendEmail && !sendWhatsApp) {
      message.error("Please select at least one message channel.");
      return;
    }

    if (sendEmail && !selectedEmailTemplate) {
      message.error("Please select an email template.");
      return;
    }

    if (sendWhatsApp && !selectedWhatsAppTemplate) {
      message.error("Please select a WhatsApp template.");
      return;
    }

    try {
      setSubmitting(true);

      const recipient = selectedRecipient;

      const phone =
        recipient.phone || recipient.phonenumber || recipient.mobile || "";

      const payload = {
        relType: recordType,
        relId: recipient.id,
        recipientName: recipient.name || "",
        name: recipient.name || "",
        email: recipient.email || "",
        phone,
        mobileNumber: phone,
        company: recipient.company || recipient.companyname || "",
        numbers: phone,

        sendEmail,
        sendWhatsApp,

        emailTemplateId: selectedEmailTemplate?.value || null,
        emailTemplateName: selectedEmailTemplate?.label || "",
        emailSubject: emailSubject || "",
        emailBody: prefilledMessage || "",

        whatsAppTemplateId: selectedWhatsAppTemplate?.name || null,
        whatsAppTemplateName: selectedWhatsAppTemplate?.name || "",
        whatsappTemplateName: selectedWhatsAppTemplate?.name || "",
        whatsAppBody: selectedWhatsAppTemplate?.body || "",

        notes: values?.notes || "",
      };

      const response = await fetch(`${BASE_CRM_URL}notifications/SendMessage`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json().catch(() => ({}));
      const result = data?.ResultData ?? data;

      if (!response.ok) {
        throw new Error(
          data?.Message ||
            data?.message ||
            `Request failed with status ${response.status}`,
        );
      }

      if (!result?.results && data?.Status === false) {
        throw new Error(
          data?.Message || "The server could not process the message.",
        );
      }

      // Let MessageHub show the actual API result.
      await onSubmit({
        ...payload,
        apiResult: result,
      });

      await Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Message submitted successfully.",
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
        allowOutsideClick: false,
      });

      form.resetFields();
    } catch (error) {
      console.error("Send message error:", error);
      message.error(error.message || "Unable to send the message.");
    } finally {
      setSubmitting(false);
      setSaving(false);
    }
  };
  const relatedName = (selectedRelatedName || "").toLowerCase();

  const isLead = relatedName.includes("lead");

  const isCustomer =
    relatedName.includes("customer") || relatedName.includes("client");

  const resetDrawer = () => {
    form.resetFields();

    setRecordType("lead");
    setSelectedRecipient(null);

    setSelectedRelated(null);
    setSelectedRelatedName("");

    setSelectedLead([]);
    setSelectedCustomer([]);

    setSelectedEmailTemplate(null);
    setSelectedWhatsAppTemplate(null);

    setEmailTemplate("");
    setEmailSubject("");
    setPrefilledMessage("");

    setSendEmail(true);
    setSendWhatsApp(true);
  };

  const handleDrawerClose = () => {
    resetDrawer();
    onClose();
  };

  return (
    <>
      {saving && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <Drawer
        title={
          <div className="d-flex align-items-center">
            <div className="fw-bold" style={{ color: "#1B2850" }}>
              Send Message
            </div>
          </div>
        }
        placement="right"
        width={560}
        open={open}
        onClose={handleDrawerClose}
        closable={false}
        destroyOnClose
        extra={
          <div className="d-flex justify-content-end gap-2">
            <Button
              onClick={handleDrawerClose}
              shape="circle"
              className="d-flex align-items-center justify-content-center"
              style={{
                backgroundColor: "#ffff",
                borderColor: "#ddd6d6",
                color: "#dc3545",
                width: 35,
                height: 35,
              }}
              icon={<i className="fa-solid fa-xmark" />}
              title="Cancel"
            />

            <Button
              type="primary"
              shape="circle"
              loading={submitting}
              onClick={() => form.submit()}
              className="d-flex align-items-center justify-content-center"
              style={{
                backgroundColor: "#fafdfc",
                borderColor: "#ddd6d6",
                color: "#25e00d",
                width: 35,
                height: 35,
              }}
              icon={<i className="fa-solid fa-check " />}
              title="Send Message"
            />
          </div>
        }
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          requiredMark="optional"
        >
          {/* 1. Lead / Customer */}
          <div className="row g-3 mb-3">
            <div className="col-md-6 col-12">
              <label className="form-label fw-semibold">
                Select Type <span className="text-danger">*</span>
              </label>

              <Select
                className={
                  showValidation && !selectedRelated
                    ? "required-select-error"
                    : ""
                }
                value={selectedRelated}
                loading={relatedLoading}
                placeholder="Select Related"
                style={{ width: "100%", height: 38 }}
                options={relatedOptions}
                onChange={handleRelatedChange}
              />

              {showValidation && !selectedRelated && (
                <div className="text-danger small mt-1">
                  Please select a related type.
                </div>
              )}
            </div>

            {/* 2. Select Lead / Customer */}
            <div className="col-md-6 col-12">
              <label className="form-label fw-semibold">
                Select{" "}
                {selectedRelatedName.toLowerCase().includes("lead") &&
                !selectedRelatedName.toLowerCase().includes("customer")
                  ? "Lead"
                  : "Customer"}
                <span className="text-danger"> *</span>
              </label>

              <Select
                showSearch
                style={{ width: "100%", minHeight: 38 }}
                placeholder={
                  !selectedRelated
                    ? "Select Related first"
                    : isLead
                      ? "Select Lead"
                      : isCustomer
                        ? "Select Customer"
                        : "Lead / Customer"
                }
                disabled={!selectedRelated}
                loading={
                  isLead
                    ? leadOptions.length === 0
                    : isCustomer
                      ? customerOptions.length === 0
                      : false
                }
                options={
                  isLead ? leadOptions : isCustomer ? customerOptions : []
                }
                value={
                  isLead
                    ? selectedLead[0] || undefined
                    : isCustomer
                      ? selectedCustomer[0] || undefined
                      : undefined
                }
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={(value) => {
                  if (isLead) {
                    const option = leadOptions.find(
                      (item) => item.value === value,
                    );

                    const record = option?.record;

                    setSelectedLead(value ? [value] : []);
                    setSelectedCustomer([]);

                    setSelectedRecipient(
                      record
                        ? {
                            ...record,
                            id: record.id ?? record.leadid ?? value,
                            name:
                              record.name ||
                              `${record.firstname || ""} ${record.lastname || ""}`.trim(),
                            email:
                              record.email ||
                              record.emailaddress ||
                              record.email_addr ||
                              "",
                            phone:
                              record.phone ||
                              record.phonenumber ||
                              record.mobile ||
                              "",
                          }
                        : null,
                    );
                  } else if (isCustomer) {
                    const option = customerOptions.find(
                      (item) => item.value === value,
                    );

                    const record = option?.record;

                    setSelectedCustomer(value ? [value] : []);
                    setSelectedLead([]);

                    setSelectedRecipient(
                      record
                        ? {
                            ...record,
                            id: record.customerId ?? record.id ?? value,
                            name:
                              record.name ||
                              record.company ||
                              record.companyname ||
                              "",
                            email:
                              record.email ||
                              record.emailaddress ||
                              record.email_addr ||
                              "",
                            phone:
                              record.phone ||
                              record.phonenumber ||
                              record.mobile ||
                              "",
                          }
                        : null,
                    );
                  } else {
                    setSelectedLead([]);
                    setSelectedCustomer([]);
                    setSelectedRecipient(null);
                  }
                }}
              />
            </div>
          </div>

          {/* Recipient Details */}
          {selectedRecipient && (
            <div className="row mb-3">
              <div className="col-12">
                <div
                  className="rounded-3 p-3"
                  style={{
                    background: "#F7F9FC",
                    border: "1px solid #E5EAF2",
                  }}
                >
                  <div className="fw-bold mb-2">
                    <i
                      className="fa-solid fa-user me-2"
                      style={{ color: "#1B2850" }}
                    />
                    {selectedRecipient.name}
                  </div>

                  <div className="row g-2">
                    <div className="col-md-6 col-12 small text-muted">
                      <i className="fa-regular fa-envelope me-2" />
                      {selectedRecipient.email || "No email address"}
                    </div>

                    <div className="col-md-6 col-12 small text-muted">
                      <i className="fa-solid fa-phone me-2" />
                      {selectedRecipient.phone || "No phone number"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="row g-3">
            {/* 3. Email Template */}

            <div className="col-6">
              <label className="form-label fw-semibold">
                Email Template <span className="text-danger">*</span>
              </label>

              <Select
                showSearch
                placeholder="Select email template"
                style={{ width: "100%", height: 38 }}
                loading={emailTemplateLoading}
                value={emailTemplate || undefined}
                options={emailTemplates}
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label || "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={(value) => {
                  setEmailTemplate(value);

                  const template = emailTemplates.find(
                    (item) => item.value === value,
                  );

                  setSelectedEmailTemplate(template || null);

                  const recipient = getSelectedRecipient();

                  const placeholderValues = {
                    contact_firstname:
                      recipient?.firstname ||
                      recipient?.first_name ||
                      recipient?.name?.split(" ")[0] ||
                      "",

                    contact_lastname:
                      recipient?.lastname ||
                      recipient?.last_name ||
                      recipient?.name?.split(" ").slice(1).join(" ") ||
                      "",

                    companyname:
                      recipient?.company || recipient?.companyname || "",

                    crm_url: window.location.origin,

                    email_signature: "Support Team",
                  };

                  const renderedMessage = replacePlaceholders(
                    template?.message || "",
                    placeholderValues,
                  );

                  const renderedSubject = replacePlaceholders(
                    template?.subject || "",
                    placeholderValues,
                  );

                  setPrefilledMessage(renderedMessage);
                  setEmailSubject(renderedSubject);
                }}
              />
            </div>

            <div className="col-md-6 col-12">
              <label className="form-label fw-semibold">
                WhatsApp Template <span className="text-danger">*</span>
              </label>

              <Select
                showSearch
                optionFilterProp="label"
                placeholder="Select WhatsApp template"
                style={{ width: "100%", height: 38 }}
                value={selectedWhatsAppTemplate?.name}
                onChange={handleWhatsAppTemplateChange}
                options={whatsappTemplates.map((item) => ({
                  value: item.name,
                  label: item.name,
                }))}
              />
            </div>

            {/* Prefilled Email Message */}

            <div className="col-12">
              <label className="form-label fw-semibold">Email Subject</label>

              <input
                type="text"
                className="form-control mb-3"
                value={emailSubject}
                onChange={(e) => setEmailSubject(e.target.value)}
              />

              <label className="form-label fw-semibold">Email Preview</label>

              <QuillEditor
                key={`${emailTemplate}-${selectedRecipient?.id || ""}`}
                initialValue={prefilledMessage}
                onChange={setPrefilledMessage}
              />
            </div>
          </div>
        </Form>
      </Drawer>
    </>
  );
};

SendMessageDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default SendMessageDrawer;
